import React, { useState, useEffect, useRef } from 'react';

const RosterNotesCard = ({
	user,
	roster,
	get_notes_by_roster_endpoint,
	update_notes_by_roster_endpoint,
	isDraftModeEnabled
}) => {
	const [
		notes,
		setNotes
	] = useState('');
	const [
		showSuccessMessage,
		setShowSuccessMessage
	] = useState(false);
	const [
		isExpanded,
		setIsExpanded
	] = useState(false);
	const debounceTimeout = useRef(null);

	const getNotes = async () => {
		const endpoint = get_notes_by_roster_endpoint
			.replace('user_id', user.id)
			.replace('roster_id', roster.id);

		try {
			const response = await fetch(endpoint);
			if (!response.ok) {
				throw new Error('Failed to fetch notes');
			}

			const data = await response.json();
			setNotes(data.data || '');
		} catch (error) {
			console.error('Error fetching notes:', error);
		}
	};

	const saveNotes = async (newNotes) => {
		const endpoint = update_notes_by_roster_endpoint
			.replace('user_id', user.id)
			.replace('roster_id', roster.id);

		try {
			const response = await fetch(endpoint, {
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ notes: newNotes })
			});

			if (!response.ok) {
				throw new Error('Failed to update notes');
			}

			setShowSuccessMessage(true);
			await getNotes();

			setTimeout(() => {
				setShowSuccessMessage(false);
			}, 1500);
		} catch (error) {
			console.error('Failed to update notes:', error);
		}
	};

	const handleNotesChange = (e) => {
		const newNotes = e.target.value;
		setNotes(newNotes);

		if (debounceTimeout.current) {
			clearTimeout(debounceTimeout.current);
		}

		debounceTimeout.current = setTimeout(() => {
			saveNotes(newNotes);
		}, 1500); // Save after 1.5 second of inactivity
	};

	useEffect(() => {
		getNotes();

		return () => {
			if (debounceTimeout.current) {
				clearTimeout(debounceTimeout.current);
			}
		};
	}, []);

	return (
		<div>
			<div
				className={`relative flex-1 bg-gray-100 dark:bg-dark-bg rounded-lg p-4 shadow-md flex flex-col w-full lg:w-auto ${isExpanded
					? 'h-96'
					: isDraftModeEnabled ? 'h-24 md:h-48' : 'h-48 md:h-60'}`}
			>
				<h3 className="font-semibold text-lg mb-2 text-gray-700 dark:text-dark-text uppercase border-b border-gray-300 dark:border-dark-border pb-2">
					NOTES
				</h3>
				<textarea
					value={notes}
					onChange={handleNotesChange}
					className="text-gray-700 dark:text-dark-text flex-1 text-sm p-2 rounded-lg w-full h-full bg-gray-100 dark:bg-dark-bg overflow-y-auto placeholder-gray-500 dark:placeholder-dark-text-secondary"
					placeholder="Click to add notes, to-dos, etc."
				/>
				<div className="text-right mt-2">
					<button
						onClick={() => setIsExpanded(!isExpanded)}
						className="text-blue-500 text-sm hover:underline focus:outline-none"
					>
						{isExpanded ? 'Collapse' : 'Expand'}
					</button>
				</div>
				{showSuccessMessage && (
					<div className="absolute inset-0 flex items-center justify-center bg-gray-100 dark:bg-dark-bg rounded-lg transition-opacity duration-500">
						<div className="flex flex-col items-center">
							<i className="fa-regular fa-circle-check text-green-500 text-2xl" />
							<span className="text-green-500">Saved.</span>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default RosterNotesCard;
